import { Controller } from "@hotwired/stimulus"

// Flags the element with .keyboard-open while a phone's on-screen keyboard is up, so the sticky
// « Payer » bar can step aside (shop_cart.css). A focus alone is not enough: Android's Back closes
// the keyboard without a blur, and the bar is the only « Payer » on a phone.
// The keyboard shrinks the visual viewport; in-app browsers (WebViews) and older Chrome shrink the
// window too, so the visible height is compared with the tallest one seen at this width (reset on
// rotation), not with the current innerHeight. A URL bar showing or hiding stays under the threshold.
// The keyboard is only up while a field (or Stripe's iframe) has the focus: a narrow desktop window
// made shorter must not hide the bar.
const KEYBOARD_MIN_PX = 150
const EDITABLE = "input:not([type=radio]):not([type=checkbox]):not([type=button]):not([type=submit]), select, textarea, iframe"

export default class extends Controller {
  connect() {
    if (!window.visualViewport) return

    this.measure = () => {
      const viewport = window.visualViewport
      if (window.innerWidth !== this.width) {
        this.width = window.innerWidth
        this.fullHeight = 0
      }
      this.fullHeight = Math.max(this.fullHeight, window.innerHeight)
      const covered = this.fullHeight - viewport.height * viewport.scale
      const focused = document.activeElement
      const typing = focused !== null && this.element.contains(focused) && focused.matches(EDITABLE)
      this.element.classList.toggle("keyboard-open", typing && covered > KEYBOARD_MIN_PX)
    }
    // Measured a frame later on a blur: going from one field to the next, the focus lands after it.
    this.blurred = () => requestAnimationFrame(this.measure)
    window.visualViewport.addEventListener("resize", this.measure)
    window.addEventListener("resize", this.measure)
    this.element.addEventListener("focusin", this.measure)
    this.element.addEventListener("focusout", this.blurred)
    this.measure()
  }

  disconnect() {
    if (!this.measure) return
    window.visualViewport.removeEventListener("resize", this.measure)
    window.removeEventListener("resize", this.measure)
    this.element.removeEventListener("focusin", this.measure)
    this.element.removeEventListener("focusout", this.blurred)
    this.element.classList.remove("keyboard-open")
  }
}
